import React from "react";
const ArrowRightIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 5L15.25 12L8.25 19"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="square"
      />
    </svg>
  );
};

export default ArrowRightIcon;
